import { Box, Button, Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { postData } from '../../../../../../DataAccessLayer';
import { cctClass } from '../../../../../../DataAccessLayer/services';
import { toast } from 'react-toastify';
import { ZoomTabMapping } from '../config';
import { MeetingDateFormat, OptionsMapping, RecurringOptions } from './config';
import { DayMapping, monthsList } from '../../../../../common/constants';
import { FormCheckbox } from '../../../../../common/Form/FormCheckbox';
import { FormButton } from '../../../../../common/Form/FormButton';
import { getUserEmail } from './utils';
import { Time } from '../../../../../common/MomentTime';
import PortalTime from '../../../../../common/PortalTime';
import { WithSmallScreen } from '../../../../../common/WithSmallScreen';

class ClassMeetings extends Component {
  state = {
    isLoading: false,
    isCustomDate: false,
    customStartDate: dayjs(this.props.course?.START_DATE),
    customEndDate: dayjs(this.props.course?.END_DATE),
    customStartTime: dayjs(this.props.course?.START_DATE + 'T' + this.props.course?.BEGIN_TIME),
    customEndTime: dayjs(this.props.course?.START_DATE + 'T' + this.props.course?.END_TIME),
    [OptionsMapping.isRecordMeeting]: true,
    [OptionsMapping.isPublishToCanvas]: false,
    [OptionsMapping.isJoinBeforeHost]: false,
    [OptionsMapping.isHideMeeting]: false,
    isExpand: false,
    weekDays: {},
  };

  componentDidMount() {
    this.createWeekDays();
  }

  //Θ(N) where N is the number of weekdays the course meeting is scheduled on
  //Maps weekday code to full weekday name.
  createWeekDays = () => {
    if (this.props?.course && this.props.course?.isClassScheduled) {
      let weekDays = [...this.props.course?.MEETING_DAYS.replace('<BR>', '')]
        .map((shortWeekDay) => {
          let longWeekDay = DayMapping[shortWeekDay];
          return RecurringOptions.weekly.weekdays[longWeekDay.toLowerCase()]?.name;
        })
        .reduce((weekdays, newWeekday) => {
          return { ...weekdays, [newWeekday]: true };
        }, {});
      this.setState({
        weekDays,
      });
    }
  };

  toggleIsLoading = (isLoading = !this.state.isLoading) => {
    this.setState({
      isLoading,
    });
  };

  toggleIsExpand = (isExpand = !this.state.isExpand) => {
    this.setState({
      isExpand,
    });
  };

  //Θ(1) sets start and end dates
  setCustomDates = (value) => {
    let customStartDate = value[0];
    let customEndDate = value[1];

    if (customStartDate && customEndDate) {
      this.setState({
        customStartDate,
        customEndDate,
      });
    }
  };

  //Θ(1) sets dates
  setDate = (value, name) => {
    this.setState({
      [name]: value,
    });
  };

  //Θ(1) updates values of respective checkboxes
  onCheckbox = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  //Θ(1) returns the topic
  getTopic = (course) => {
    let crns = course?.CRNS?.split(',');

    if (crns?.length)
      return (
        course.SSBSECT_TERM_CODE +
        '_' +
        course.SUBJECT_CODE +
        '_' +
        course.COURSE_NUMBER +
        '_' +
        crns[0]
      );
    else return '';
  };

  //Θ(1) returns the topic to be displayed in input
  getDisplayTopic = (course) => {
    let crns = course?.CRNS?.split(',');

    if (crns?.length) return course.SUBJECT_CODE + ' ' + course.COURSE_NUMBER + ' Class Meetings';
    else return '';
  };

  //Θ(N) where N is the length of meeting days
  //Returns class meeting details in short
  getClassShortDetails = (course) => {
    const schedule = course?.SCHEDULE;
    if (schedule) {
      return schedule.map((entry) => {
        let details = '';
        if (course?.CRNS && entry?.MEETING_DAYS) {
          const startDate = Time.Local(course.START_DATE);

          const endDate = Time.Local(course.END_DATE);

          const meetingDays = entry?.MEETING_DAYS.replace('<BR>', '');

          const weekdays = [...meetingDays].reduce((weekday, shortWeekDay, index, array) => {
            if (index === 0) weekday += DayMapping[shortWeekDay];
            else if (index === array.length - 1) weekday += ' and ' + DayMapping[shortWeekDay];
            else weekday += ', ' + DayMapping[shortWeekDay];

            return weekday;
          }, '');

          const timeFormat = 'h:mm A';

          const startTime = dayjs(course?.START_DATE + 'T' + entry?.BEGIN_TIME);
          const formattedStartTime = startTime?.format(timeFormat);

          const endTime = dayjs(course?.START_DATE + 'T' + entry?.END_TIME);
          const formattedEndTime = endTime?.format(timeFormat);

          return (
            <Typography
              key={`${entry.MEETING_DAYS}-${entry.TIMES}`}
              sx={{ display: 'flex', flexWrap: 'wrap' }}
            >
              {`${monthsList[startDate.month()]} ${startDate.date()} - ${monthsList[endDate.month()]} ${endDate.date()}, ${startDate.year()}, ${weekdays} from `}
              <PortalTime startTime={formattedStartTime} endTime={formattedEndTime} />
            </Typography>
          );
        }

        return details;
      });
    }

    return [];
  };

  //Θ(1) Creates a meeting by hitting backend api
  onSchedule = () => {
    this.toggleIsLoading(true);
    let course = this.props.course;

    let topic = this.getTopic(course);
    let agenda = 'Meeting for ' + course.CRNS;
    let record = this.state.isRecordMeeting;
    let joinBeforeHost = this.state.isJoinBeforeHost;
    let hideMeetings = this.state[OptionsMapping.isHideMeeting];
    let preferredStartDate = Time.Local(this.state.customStartDate['$d']).format(MeetingDateFormat);
    let preferredEndDate = Time.Local(this.state.customEndDate['$d']).format(MeetingDateFormat);
    let publishKaltura = this.state.isPublishToCanvas;

    let email = getUserEmail(this.props.user, this.props.impersonation);

    let meetingDetails = {
      crns: course.CRNS,
      termCode: course.SSBSECT_TERM_CODE,
      topic,
      agenda,
      email,
      publishKaltura,
      record,
      joinBeforeHost,
      hideMeetings,
      //We dont need to send custom dates in new portal
      // ...(this.state.isCustomDate && {
      //     preferredStartDate,
      //     preferredEndDate
      // }) //Dates added only if Custom dates checkbox checked
    };

    postData(cctClass, meetingDetails, true)
      .then((result) => {
        if (!result) toast.error('Unable to create meetings');
        else {
          this.props.onTabChange('', ZoomTabMapping.currentMeeting);
          this.props.toggleIsScheduleMeeting(false);
          toast.success('Meetings Created');
        }
        this.toggleIsLoading(false);
      })
      .catch((err) => {
        this.toggleIsLoading(false);
        toast.error('Unable to create meeting');
        console.log(err);
      });
  };

  render() {
    let course = this.props.course;
    let topic = this.getDisplayTopic(course);

    return (
      <React.Fragment>
        <Box sx={{ marginTop: 2 }}>
          <Row>
            <Col>
              <Typography variant="h4" component="h4">
                Schedule Class Meetings
              </Typography>
            </Col>
          </Row>
          <Box sx={{ padding: '1rem' }}>
            <Row style={{ padding: 4 }}>
              <Grid container spacing={1} alignItems={'center'}>
                <Grid item xs={12} md={2} textAlign={{ xs: 'start', md: 'end' }}>
                  <Typography className="myOdu__label">Meeting Title</Typography>
                </Grid>
                <Grid item xs={12} md={10}>
                  <Typography>{topic}</Typography>
                </Grid>
              </Grid>
            </Row>

            <Row style={{ padding: 4 }}>
              <Row style={{ width: '100%' }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={2} textAlign={'start'}>
                    <Grid
                      container
                      justifyContent={{
                        xs: 'start',
                        md: 'end',
                      }}
                    >
                      <Grid xs="auto" item>
                        <Typography className="myOdu__label">Class Details</Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>{this.getClassShortDetails(course)}</Grid>
                </Grid>
              </Row>
            </Row>

            <Row style={{ padding: 4 }}>
              <Row style={{ width: '100%' }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={2} textAlign={{ xs: 'start', md: 'end' }}>
                    <Typography className="myOdu__label">Options</Typography>
                  </Grid>
                  <Grid item alignItems="center" xs={12} md={10}>
                    <FormCheckbox
                      label={'Record Meeting'}
                      onChange={this.onCheckbox}
                      name={OptionsMapping.isRecordMeeting}
                      labelGridProps={{
                        xs: 0,
                      }}
                      inputGridProps={{
                        xs: 12,
                        md: 9,
                        lg: 8,
                        xl: 9,
                      }}
                      value={this.state[OptionsMapping.isRecordMeeting]}
                      sx={{ marginRight: '0.25rem' }}
                    />
                    <FormCheckbox
                      label={'Automatically Publish Recording to Canvas'}
                      onChange={this.onCheckbox}
                      name={OptionsMapping.isPublishToCanvas}
                      labelGridProps={{
                        xs: 0,
                      }}
                      inputGridProps={{
                        xs: 12,
                        md: 9,
                        lg: 8,
                        xl: 9,
                      }}
                      value={this.state[OptionsMapping.isPublishToCanvas]}
                      sx={{ marginRight: '0.25rem' }}
                    />
                    <FormCheckbox
                      label={'Allow Participants to Join Before Host'}
                      onChange={this.onCheckbox}
                      name={OptionsMapping.isJoinBeforeHost}
                      labelGridProps={{
                        xs: 0,
                      }}
                      inputGridProps={{
                        xs: 12,
                        md: 9,
                        lg: 8,
                        xl: 9,
                      }}
                      value={this.state[OptionsMapping.isJoinBeforeHost]}
                      sx={{ marginRight: '0.25rem' }}
                    />
                    <FormCheckbox
                      label={'Hide Meeting from Students'}
                      onChange={this.onCheckbox}
                      name={OptionsMapping.isHideMeeting}
                      labelGridProps={{
                        xs: 0,
                      }}
                      inputGridProps={{
                        xs: 12,
                        md: 9,
                        lg: 8,
                        xl: 9,
                      }}
                      value={this.state[OptionsMapping.isHideMeeting]}
                      sx={{ marginRight: '0.25rem' }}
                    />
                  </Grid>
                </Grid>
              </Row>
            </Row>
          </Box>
          <Grid container spacing={1} justifyContent={'flex-end'}>
            <Grid item xs={12} md={'auto'}>
              <FormButton
                label={'Cancel'}
                id="backToScheduleMeeting"
                onClick={this.props.onToggle}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={'auto'}>
              <Button
                onClick={this.onSchedule}
                disabled={this.state.isLoading}
                variant="outlined"
                className="myOdu__button scheduleMeetings primary"
                fullWidth
              >
                Schedule Class Meetings
              </Button>
            </Grid>
          </Grid>
        </Box>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    course: state.CCTReducer.course,
    user: state.AWSReducer.user,
    impersonation: state.impersonationReducer.impersonation,
    meetings: state.CCTReducer.meetings,
  };
};

export default connect(mapStateToProps)(WithSmallScreen(ClassMeetings));
